import Draggable from "react-draggable";
import classNames from "classnames";
import {
  useState,
  useEffect,
  useContext,
  useCallback,
  useRef,
  forwardRef,
} from "react";
import { ShareStatus } from "@zoom/videosdk";
import { SHARE_CANVAS_ID } from "../video-constants";
import "./share-bar.scss";
import { ZoomMediaContext } from "../../../ZoomMediaProvider";
import { ZoomContext } from "../../zoom-context";
import { Button } from "@mui/material";

interface ShareBarProps {
  className?: string;
  controllingUser?: { userId: number; displayName: string } | null;
}

const ShareBar = forwardRef((_props: ShareBarProps, ref: any) => {
  // const { controllingUser } = props;
  const zmClient = useContext(ZoomContext);
  const mediaContext = useContext(ZoomMediaContext);

  if (!mediaContext) {
    throw new Error("ZoomMediaContext is not available. ");
  }

  const { mediaStream } = mediaContext;
  const [status, setStatus] = useState<ShareStatus | undefined>(
    mediaStream?.getShareStatus()
  );
  // const [hideShareAudioTooltip, setHideShareAudioTooltip] = useState(false);
  const [_shareAudioStatus, setShareAudioStatus] = useState(
    mediaStream?.getShareAudioStatus()
  );

  const draggableRef = useRef<HTMLDivElement>(null);
  const onShareAudioChange = useCallback(() => {
    setShareAudioStatus(mediaStream?.getShareAudioStatus());
  }, [mediaStream]);
  // const onShareAudioClick = useCallback(() => {
  //   if (shareAudioStatus?.isShareAudioEnabled) {
  //     if (shareAudioStatus.isShareAudioMuted) {
  //       mediaStream?.unmuteShareAudio().then(() => {
  //         setShareAudioStatus(mediaStream.getShareAudioStatus());
  //       });
  //     } else {
  //       mediaStream?.muteShareAudio().then(() => {
  //         setShareAudioStatus(mediaStream.getShareAudioStatus());
  //       });
  //     }
  //   }
  // }, [mediaStream, shareAudioStatus]);

  const onSharePauseClick = useCallback(() => {
    if (status === ShareStatus.Paused) {
      mediaStream?.resumeShareScreen();
    } else if (status === ShareStatus.Sharing) {
      mediaStream?.pauseShareScreen();
    }
  }, [mediaStream, status]);
  const onShareStatusChange = useCallback(() => {
    setTimeout(() => {
      if (status !== mediaStream?.getShareStatus()) {
        setStatus(mediaStream?.getShareStatus());
      }
    });
  }, [status, mediaStream]);
  useEffect(() => {
    zmClient?.on("share-audio-change", onShareAudioChange);
    zmClient?.on("user-updated", onShareStatusChange);
    return () => {
      zmClient?.off("share-audio-change", onShareAudioChange);
      zmClient?.off("user-updated", onShareStatusChange);
    };
  }, [zmClient, onShareAudioChange, onShareStatusChange]);

  return (
    <div
      className={classNames({ "share-bar-hide": status === ShareStatus.End })}
    >
      <Draggable handle=".share-bar-move" nodeRef={draggableRef}>
        <div className="screen-share-control-bar" ref={draggableRef}>
          <Button className="share-bar-move" />
          <div className="share-bar-tip">
            {status === ShareStatus.Sharing
              ? "You're sharing the screen"
              : "Your screen sharing is paused"}
          </div>
          {mediaStream?.isStartShareScreenWithVideoElement() ? (
            <video
              id={SHARE_CANVAS_ID}
              className="share-bar-canvas"
              ref={ref}
            />
          ) : (
            <canvas
              id={SHARE_CANVAS_ID}
              className="share-bar-canvas"
              ref={ref}
            />
          )}
          {/* {shareAudioStatus?.isShareAudioEnabled && (
            <Popconfirm
              title="Your microphone is disabled when sharing computer audio. When you pause or stop sharing audio, your microphone will be reactivated."
              disabled={
                mediaStream?.isSupportMicrophoneAndShareAudioSimultaneously() ||
                hideShareAudioTooltip
              }
              showCancel={false}
              okText="Got it"
              okType="link"
              onConfirm={() => setHideShareAudioTooltip(true)}
            >
              <Button
                // icon={
                //   <IconFont
                //     type={
                //       shareAudioStatus.isShareAudioMuted
                //         ? "icon-audio-off"
                //         : "icon-audio-on"
                //     }
                //   />
                // }
                className="share-bar-btn"
                onClick={onShareAudioClick}
              />
            </Popconfirm>
          )} */}
          <Button
            // icon={
            //   <IconFont
            //     type={
            //       status === ShareStatus.Paused ? "icon-resume" : "icon-pause"
            //     }
            //   />
            // }
            className="share-bar-btn"
            onClick={onSharePauseClick}
          />
          <Button
            // icon={<IconFont type="icon-stop" />}
            className="share-bar-btn"
            onClick={() => {
              mediaStream?.stopShareScreen();
            }}
          >
            Stop Share
          </Button>
        </div>
      </Draggable>
    </div>
  );
});

export default ShareBar;
